import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import exportApi from '../../api/export/hooks'
import { MODAL_TYPES } from '../../common/constants'
import { hideModal } from '../../store/modal'

const ExportSyncModal = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { mutate: triggerExportSync, isPending, isSuccess, error } = exportApi.TriggerSync.useMutation()

    const handleClose = () => {
        dispatch(hideModal({ modalType: MODAL_TYPES.EXPORT_SYNC_MODAL }))
    }

    return (
        <Modal isOpen={true} centered>
            <ModalHeader className="border-bottom ms-3 ps-2 pb-3 me-3 pe-2">{t('modal.sync.title')}</ModalHeader>
            <ModalBody>
                {(isPending || isSuccess || error) && (
                    <div className={`mb-4 mt-1 ${error ? 'bg-soft-danger' : 'bg-soft-success'}`}>
                        <p className="pt-3 ps-3">
                            {isPending ? t('modal.sync.messageProgress') : error ? t('modal.sync.messageError') : t('modal.sync.messageDone')}
                        </p>
                        <div className="progress progress-lg rounded-0 rounded-bottom">
                            <div
                                className={`progress-bar w-100 ${error ? 'bg-danger' : 'progress-bar-striped bg-success'} ${isPending && 'progress-bar-animated'}`}
                                role="progressbar"
                            ></div>
                        </div>
                    </div>
                )}
                <div className="d-flex justify-content-end">
                    <Button color="success" className="btn-label me-3" disabled={isPending} onClick={() => triggerExportSync()}>
                        <i className="mdi mdi-check label-icon align-middle fs-16 me-2"></i> {t('modal.sync.buttonStart')}
                    </Button>
                    <Button color="primary" className="btn-label" onClick={handleClose} disabled={isPending}>
                        <i className="mdi mdi-close label-icon align-middle fs-16 me-2"></i>
                        {t('modal.sync.buttonClose')}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default ExportSyncModal
